/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FlightObservedItinerary } from "./FlightObservedItinerary";
import {
  FlightObservedItineraryFromJSON,
  FlightObservedItineraryFromJSONTyped,
  FlightObservedItineraryToJSON,
  FlightObservedItineraryToJSONTyped,
} from "./FlightObservedItinerary";

/**
 *
 * @export
 * @interface FlightBookingReviewResponse
 */
export interface FlightBookingReviewResponse {
  /**
   *
   * @type {number}
   * @memberof FlightBookingReviewResponse
   */
  schemaVersion: FlightBookingReviewResponseSchemaVersionEnum;
  /**
   *
   * @type {boolean}
   * @memberof FlightBookingReviewResponse
   */
  test: boolean;
  /**
   *
   * @type {string}
   * @memberof FlightBookingReviewResponse
   */
  bookingId: string;
  /**
   *
   * @type {string}
   * @memberof FlightBookingReviewResponse
   */
  reviewId: string;
  /**
   *
   * @type {number}
   * @memberof FlightBookingReviewResponse
   */
  generation: number;
  /**
   *
   * @type {string}
   * @memberof FlightBookingReviewResponse
   */
  kind: FlightBookingReviewResponseKindEnum;
  /**
   *
   * @type {string}
   * @memberof FlightBookingReviewResponse
   */
  status: FlightBookingReviewResponseStatusEnum;
  /**
   *
   * @type {FlightObservedItinerary}
   * @memberof FlightBookingReviewResponse
   */
  previousItinerary: FlightObservedItinerary;
  /**
   *
   * @type {FlightObservedItinerary}
   * @memberof FlightBookingReviewResponse
   */
  proposedItinerary: FlightObservedItinerary;
  /**
   *
   * @type {number}
   * @memberof FlightBookingReviewResponse
   */
  totalAmount: number;
  /**
   *
   * @type {string}
   * @memberof FlightBookingReviewResponse
   */
  currency: string;
  /**
   *
   * @type {Array<string>}
   * @memberof FlightBookingReviewResponse
   */
  reasonCodes: Array<string>;
  /**
   *
   * @type {Date}
   * @memberof FlightBookingReviewResponse
   */
  expiresAt: Date;
  /**
   *
   * @type {string}
   * @memberof FlightBookingReviewResponse
   */
  consentVersion: string;
  /**
   *
   * @type {string}
   * @memberof FlightBookingReviewResponse
   */
  consentDigest: string | null;
  /**
   *
   * @type {boolean}
   * @memberof FlightBookingReviewResponse
   */
  canAccept: boolean;
}

/**
 * @export
 */
export const FlightBookingReviewResponseSchemaVersionEnum = {
  NUMBER_1: 1,
} as const;
export type FlightBookingReviewResponseSchemaVersionEnum =
  (typeof FlightBookingReviewResponseSchemaVersionEnum)[keyof typeof FlightBookingReviewResponseSchemaVersionEnum];

/**
 * @export
 */
export const FlightBookingReviewResponseKindEnum = {
  ArrivalScheduleChange: "arrival_schedule_change",
} as const;
export type FlightBookingReviewResponseKindEnum =
  (typeof FlightBookingReviewResponseKindEnum)[keyof typeof FlightBookingReviewResponseKindEnum];

/**
 * @export
 */
export const FlightBookingReviewResponseStatusEnum = {
  Pending: "pending",
  Accepted: "accepted",
  Expired: "expired",
  Superseded: "superseded",
  NeedsAttention: "needs_attention",
} as const;
export type FlightBookingReviewResponseStatusEnum =
  (typeof FlightBookingReviewResponseStatusEnum)[keyof typeof FlightBookingReviewResponseStatusEnum];

/**
 * Check if a given object implements the FlightBookingReviewResponse interface.
 */
export function instanceOfFlightBookingReviewResponse(
  value: object
): value is FlightBookingReviewResponse {
  if (!("schemaVersion" in value) || value["schemaVersion"] === undefined)
    return false;
  if (!("test" in value) || value["test"] === undefined) return false;
  if (!("bookingId" in value) || value["bookingId"] === undefined) return false;
  if (!("reviewId" in value) || value["reviewId"] === undefined) return false;
  if (!("generation" in value) || value["generation"] === undefined)
    return false;
  if (!("kind" in value) || value["kind"] === undefined) return false;
  if (!("status" in value) || value["status"] === undefined) return false;
  if (
    !("previousItinerary" in value) ||
    value["previousItinerary"] === undefined
  )
    return false;
  if (
    !("proposedItinerary" in value) ||
    value["proposedItinerary"] === undefined
  )
    return false;
  if (!("totalAmount" in value) || value["totalAmount"] === undefined)
    return false;
  if (!("currency" in value) || value["currency"] === undefined) return false;
  if (!("reasonCodes" in value) || value["reasonCodes"] === undefined)
    return false;
  if (!("expiresAt" in value) || value["expiresAt"] === undefined) return false;
  if (!("consentVersion" in value) || value["consentVersion"] === undefined)
    return false;
  if (!("consentDigest" in value) || value["consentDigest"] === undefined)
    return false;
  if (!("canAccept" in value) || value["canAccept"] === undefined) return false;
  return true;
}

export function FlightBookingReviewResponseFromJSON(
  json: any
): FlightBookingReviewResponse {
  return FlightBookingReviewResponseFromJSONTyped(json, false);
}

export function FlightBookingReviewResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightBookingReviewResponse {
  if (json == null) {
    return json;
  }
  return {
    schemaVersion: json["schema_version"],
    test: json["test"],
    bookingId: json["booking_id"],
    reviewId: json["review_id"],
    generation: json["generation"],
    kind: json["kind"],
    status: json["status"],
    previousItinerary: FlightObservedItineraryFromJSON(
      json["previous_itinerary"]
    ),
    proposedItinerary: FlightObservedItineraryFromJSON(
      json["proposed_itinerary"]
    ),
    totalAmount: json["total_amount"],
    currency: json["currency"],
    reasonCodes: json["reason_codes"],
    expiresAt: new Date(json["expires_at"]),
    consentVersion: json["consent_version"],
    consentDigest: json["consent_digest"],
    canAccept: json["can_accept"],
  };
}

export function FlightBookingReviewResponseToJSON(
  json: any
): FlightBookingReviewResponse {
  return FlightBookingReviewResponseToJSONTyped(json, false);
}

export function FlightBookingReviewResponseToJSONTyped(
  value?: FlightBookingReviewResponse | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    schema_version: value["schemaVersion"],
    test: value["test"],
    booking_id: value["bookingId"],
    review_id: value["reviewId"],
    generation: value["generation"],
    kind: value["kind"],
    status: value["status"],
    previous_itinerary: FlightObservedItineraryToJSON(
      value["previousItinerary"]
    ),
    proposed_itinerary: FlightObservedItineraryToJSON(
      value["proposedItinerary"]
    ),
    total_amount: value["totalAmount"],
    currency: value["currency"],
    reason_codes: value["reasonCodes"],
    expires_at: value["expiresAt"].toISOString(),
    consent_version: value["consentVersion"],
    consent_digest: value["consentDigest"],
    can_accept: value["canAccept"],
  };
}
